import { render, staticRenderFns } from "./Reload.vue?vue&type=template&id=98fbf8b2&scoped=true&"
import script from "./Reload.vue?vue&type=script&lang=js&"
export * from "./Reload.vue?vue&type=script&lang=js&"
import style0 from "./Reload.vue?vue&type=style&index=0&id=98fbf8b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fbf8b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98fbf8b2')) {
      api.createRecord('98fbf8b2', component.options)
    } else {
      api.reload('98fbf8b2', component.options)
    }
    module.hot.accept("./Reload.vue?vue&type=template&id=98fbf8b2&scoped=true&", function () {
      api.rerender('98fbf8b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Reload.vue"
export default component.exports